module.exports = __webpack_public_path__ + "img/PL00235.3dd231f4.png";